import React from "react";
import Translate from "../../../localization/Translate";

export default function ({item, onCheckToggle}) {
    return (
        <tr className={"productLine"} onClick={() => {
            onCheckToggle(!item.checked);
        }}>
            <td>
                <input type={"checkbox"} readOnly={"readonly"} checked={item.checked}/>
            </td>
            <td>
                {item.product.itemName}
                <br/>
                {
                    item.product.typeOfArticle ?
                        <><Translate id={"Type of article"}/>: {item.product.typeOfArticle}</>
                        :
                        ''
                }
            </td>
            <td>
                {item.product.code}
            </td>
            <td>
                {item.product.amount}
            </td>
            <td>
                {item.product.rowTotal}
            </td>
        </tr>
    );
}
